"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _orderBy = _interopRequireDefault(require("lodash/orderBy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const sortOptions = options => {
  if (!(0, _isArray.default)(options)) return options;
  return (0, _orderBy.default)(options, ["selected", "count"], ["desc", "desc"]);
};
var _default = exports.default = sortOptions;